// 公共模块
export const G                                   = {
	blog                                         : '我的博客后端',
	go_blog_home                                 : '去前台',
	go_add                                       : '去添加',
	back                                         : '返回',
	status                                       : '状态',
	all                                          : '全部',
	more                                         : '更多',
	suggest										 : '建议',

	operation                                    : '操作',
	ok                                           : '确定',
	search                                       : '搜索',
	edit                                         : '编辑',
	save                                         : '保存',
	copy                                         : '复制',
	copy_link                                    : '复制链接',
	copy_success                                 : '复制成功',
	copy_error                                   : '复制失败',
	share                                        : '分享',
	delete                                       : '删除',
	clear                                        : '清空',
	send                                         : '发送',
	hide                                         : '隐藏',
	stats                                        : '统计',
	select                                       : '选择',
	enabled                                      : '启用',
	publish                                      : '发布',
	close                                        : '关闭',
	submit                                       : '提交',
	cancel                                       : '取消',
	look                                         : '查看',
	preview                                      : '预览',
	set_top                                      : '置顶',
	cancel_top                                   : '取消置顶',
	go_bottom                                    : '页面底部',

	closed                                       : '已关闭',
	is_publish                                   : '已发布',
	not_publish                                  : '未发布',
	not_active                                   : '未激活',
	solving                                      : '正在解决',
	is_enabled                                   : '已启用',
	not_enabled                                  : '未启用',
	is_top                                       : '已置顶',
	is_required                                  : '必读',

	please_choose_category                       : '请选择分类',
	more_conditions                              : '更多筛选条件',

	keyword                                      : '关键词',
	ip                                           : 'ip地址',
	uuid                                         : '唯一编码',
	start_time                                   : '开始时间',
	end_time                                     : '结束时间',
	finish_time                                  : '完成时间',
	username                                     : '用户名',
	identity                                     : '证件号码',
	
	tags                                         : '标签',
	add_tag                                      : '添加标签',
	tag_repeated                                 : '标签已重复',

	category_manage                              : '分类管理',
	category_list                                : '分类列表',
	add_category                                 : '添加分类',
	edit_category                                : '编辑分类',
	parent_category                              : '父分类',
	category_name                                : '分类名',
	create_user                                  : '创建人',
	create_time                                  : '创建时间',
}

export const lang                                = {
	auto                                         : '自动检测',
	zh                                           : '中文简体',
	tw                                           : '中文繁体',
	en                                           : '英语',
	ja                                           : '日语',
}

export const system                              = {
	system_setting                               : '系统设置',
}

export const notice                              = {
	notice                                       : '公告',
	notice_manage                                : '公告管理',
	add_notice                                   : '新增公告',
}

export const article                             = {
	article                                      : '文章',
	article_manage                               : '文章管理',
	article_pool                                 : '文章池',
	my_article                                   : '我的文章',
	add_article                                  : '新增文章',
}

export const survey                             = {
	survey_manage                                : '调查问卷管理',
	survey_paper                                 : '问卷池',
	add_survey                                   : '新增调查问卷',
	add_survey_paper                             : '新增问卷',
	survey_name                                  : '调查名',
	paper_name                                   : '问卷名',
}

export const workorder                           = {
	workorder_manage                             : '工单管理',
	workorder_pool                               : '工单池',
}

export const robot                               = {
	robot_manage                                 : '机器人',
	robot_speech                                 : '机器人话术',
	add_speech                                   : '新增话术',
	rule_tip                                     : '建议输入有效的文本信息',
}

export const tool                                = {
	tool_manage                                  : '工具池',
	collect_student                              : '学生家庭信息采集工具',
	category_tip                                 : '第三级样式分类即样式名称',
}

export const style                               = {
	add_style                                    : '添加样式',
	add_styleCode                                : '添加代码块',
	category_tip                                 : '第三级样式分类即样式名称',
}

export const tour                                = {
	translate                                    : '多语言翻译',
	placeholder                                  : '请输入文字',
	single_quotation_mark_to_start               : '单词前缀使用单引号包裹',
	double_quotation_marks_to_start              : '单词前缀使用双引号包裹',
	single_quotation_mark_to_end                 : '句尾使用单引号包裹',
	double_quotation_marks_to_end                : '句尾使用双引号包裹',
}



// WEBPACK FOOTER //
// ./src/assets/lang/zh.js